import { UserOutlined } from '@ant-design/icons';
import { Avatar, Col, Popover, Row } from 'antd';
import InputSearchSuffixIcon from 'components/InputSearchSuffixIcon';
import appointmentSelectors from 'features/appointment/services/selectors';
import React, { useMemo, useState, useEffect } from 'react';
import { IStaffItemData } from 'services/shop/types/staff';
import styled from 'styled-components';

type Props = {
  value?: IStaffItemData;
  onChange?: (value: IStaffItemData) => void;
};

const SelectStaff = ({ value, onChange }: Props) => {
  const staffListStore = appointmentSelectors.getListStaffAvailableBooking();

  const staffList = useMemo(
    () => staffListStore?.filter((o) => !o.anyBody) || [],
    [staffListStore]
  );
  const [search, setSearch] = useState('');
  const [open, setOpen] = useState(false);

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };

  const filteredStaffList = useMemo(() => {
    return staffList.filter((o) => o.firstName.toLowerCase().includes(search.toLowerCase()));
  }, [staffList, search]);

  const handleClickStaff = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
    staff: IStaffItemData
  ) => {
    e.stopPropagation();
    setOpen(false);
    onChange?.(staff);
  };

  useEffect(() => {
    if (value) {
      setSearch(value.firstName);
    }
  }, [value]);

  return (
    <Popover
      placement='bottomLeft'
      arrow={false}
      overlayInnerStyle={{
        padding: 0,
      }}
      content={
        <ContentContainer>
          <Row gutter={[12, 12]}>
            {filteredStaffList.map((o) => (
              <Col
                key={o.id}
                span={3}
                onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) =>
                  handleClickStaff(e, o)
                }
              >
                <LabelStaffItem>
                  <Avatar
                    src={o.urlImage || undefined}
                    size={87}
                    icon={<UserOutlined />}
                    shape='circle'
                  />
                  <div className='title'>{o.firstName}</div>
                </LabelStaffItem>
              </Col>
            ))}
          </Row>
        </ContentContainer>
      }
      trigger='click'
      open={open}
      onOpenChange={handleOpenChange}
    >
      <div style={{ minWidth: '400px' }}>
        <InputSearchSuffixIcon value={search} onChange={(value) => setSearch(value)} />
      </div>
    </Popover>
  );
};

export default SelectStaff;

const ContentContainer = styled.div`
  width: 60vw;
  height: 60vh;
  padding: 12px;
  overflow: auto;
`;

const LabelStaffItem = styled.div`
  cursor: pointer;
  display: flex;
  padding: 8px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  border: 1px solid #e9edf2;
  background: #f6f7fc;
  .title {
    color: #1d2129;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    line-height: 30px;
    text-transform: uppercase;
  }
`;
